var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"help-page",attrs:{"fluid":""}},[_c('div',{ref:"content",staticClass:"help-page__content"},[(_vm.message)?_c('p',{staticClass:"help-page__content__error"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }